module.exports = "pegasus/assets/blocks/column-2-theme3.png";